var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCheckinStart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 68,
    viewBox: "0 0 67 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 33.8311,
    r: 33.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.9998 52.3269V50.6312C52.9991 49.2497 52.5766 47.9014 51.7887 46.7665C51.0008 45.6317 49.8852 44.7645 48.5911 44.281L39.4346 41.2051",
    stroke: "var(--primary-text-color, #313639)",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5652 41.2051L18.4087 44.281C17.1146 44.7645 15.999 45.6317 15.2111 46.7665C14.4232 47.9014 14.0007 49.2497 14 50.6312V52.3269",
    stroke: "var(--primary-text-color, #313639)",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5654 37.4406V42.8074C29.1934 44.2756 31.3079 45.0883 33.5002 45.0883C35.6925 45.0883 37.807 44.2756 39.435 42.8074V37.4355",
    stroke: "var(--primary-text-color, #313639)",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3262 25.1967C26.548 23.846 30.0066 23.1504 33.5001 23.1504C36.9936 23.1504 40.4521 23.846 43.674 25.1967",
    stroke: "var(--primary-text-color, #313639)",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3262 21.3085C26.548 19.9578 30.0066 19.2622 33.5001 19.2622C36.9936 19.2622 40.4521 19.9578 43.674 21.3085",
    stroke: "var(--primary-text-color, #313639)",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5 40.457V52.3266",
    stroke: "var(--primary-text-color, #313639)",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1632 48.0879C38.247 48.0879 38.329 48.1128 38.3987 48.1593C38.4684 48.2059 38.5227 48.2721 38.5548 48.3496C38.5869 48.427 38.5953 48.5123 38.5789 48.5945C38.5626 48.6767 38.5222 48.7523 38.4629 48.8116C38.4036 48.8708 38.3281 48.9112 38.2459 48.9276C38.1636 48.9439 38.0784 48.9355 38.0009 48.9034C37.9235 48.8714 37.8573 48.817 37.8107 48.7473C37.7641 48.6776 37.7393 48.5956 37.7393 48.5118C37.7393 48.3994 37.7839 48.2916 37.8634 48.2121C37.9429 48.1326 38.0507 48.0879 38.1632 48.0879Z",
    stroke: "var(--primary-text-color, #313639)",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9565 34.5225C31.6423 35.1756 32.553 35.5399 33.5 35.5399C34.447 35.5399 35.3577 35.1756 36.0435 34.5225",
    stroke: "var(--primary-text-color, #313639)",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8044 27.7398C31.6248 27.4584 31.3723 27.231 31.0737 27.0817C30.7751 26.9324 30.4416 26.8668 30.1087 26.892C29.7759 26.8668 29.4424 26.9324 29.1438 27.0817C28.8452 27.231 28.5927 27.4584 28.4131 27.7398",
    stroke: "var(--primary-text-color, #313639)",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5871 27.7398C38.4075 27.4584 38.155 27.231 37.8564 27.0817C37.5578 26.9324 37.2243 26.8668 36.8915 26.892C36.5586 26.8668 36.2251 26.9324 35.9265 27.0817C35.6279 27.231 35.3754 27.4584 35.1958 27.7398",
    stroke: "var(--primary-text-color, #313639)",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8582 30.4072C22.4544 32.5342 21.274 34.435 19.5466 35.7401C19.4268 35.8117 19.3265 35.9117 19.2547 36.0314C19.1829 36.1511 19.1417 36.2866 19.1348 36.426C19.1279 36.5654 19.1556 36.7043 19.2153 36.8305C19.275 36.9566 19.3649 37.0661 19.4771 37.1491C20.8844 38.2468 22.6368 38.8071 24.4199 38.7295",
    stroke: "var(--primary-text-color, #313639)",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1825 30.3018C44.577 32.4683 45.7688 34.4084 47.5229 35.7397C47.6426 35.8115 47.7428 35.9117 47.8144 36.0314C47.8861 36.1511 47.9271 36.2867 47.9339 36.4261C47.9406 36.5655 47.9128 36.7044 47.8529 36.8305C47.7931 36.9565 47.703 37.0659 47.5908 37.1488C46.1836 38.2467 44.4311 38.807 42.6479 38.7291",
    stroke: "var(--primary-text-color, #313639)",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6736 26.909V17.7525C43.6735 17.0287 43.442 16.3239 43.0127 15.7412C42.5834 15.1585 41.979 14.7284 41.2878 14.5138C36.2113 12.9375 30.7762 12.9375 25.6997 14.5138C25.0115 14.7302 24.4103 15.1604 23.9833 15.742C23.5564 16.3235 23.3261 17.026 23.3257 17.7474V26.9039C21.8912 27.6788 22.3558 30.9616 24.1736 31.7857C24.4265 31.9009 24.6473 32.0765 24.8164 32.2971C24.9856 32.5177 25.0979 32.7765 25.1435 33.0507C25.8879 37.5407 31.1478 40.4573 33.4997 40.4573C35.8515 40.4573 41.1097 37.5374 41.8575 33.0541C41.9031 32.7799 42.0154 32.5211 42.1846 32.3005C42.3537 32.0799 42.5745 31.9043 42.8274 31.7891C44.6401 30.9616 45.1047 27.6856 43.6736 26.909Z",
    stroke: "var(--primary-text-color, #313639)",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckinStart);
export default __webpack_public_path__ + "static/media/Icon_checkin_start.c90b45e9.svg";
export { ForwardRef as ReactComponent };